import { observer } from 'mobx-react-lite';
import { useFormContext } from 'react-hook-form';
import { useBootstrapState } from '../../../bootstrap/bootstrap-provider';
import { useEnabledFeatures } from '../../../common/hooks/enabled-features/use-enabled-features';
import { FormBody } from '../../../forms/integrated-form-components/form-body';
import { useEventMetadataStore } from '../../event-panel-form/event-metadata';
import { useAllowAddingTowVehicles } from '../../use-allow-adding-tow-vehicles';
import { EventPanelTab } from '../components/event-panel-tab';
import { TabBody } from '../../../panels/entity-panels/tabs/tab-body';
import { TabSubtitle } from '../../../panels/entity-panels/tabs/tab-subtitle';
import { Box } from '@cad-arc';
import { EventPanelFormVehiclesFields } from '../../event-panel-form/involved-person-vehicle-fields/vehicles/event-panel-form-vehicles-fields';
import { EventPanelFormArrayCount } from '../components/event-panel-form-array-count';
import { EventPanelFormType } from '@mark43/cad-api';

export const VehiclesTab = observer(function VehiclesTab() {
    const eventForm = useFormContext<EventPanelFormType>();
    const eventPanelOptions = useBootstrapState().eventPanelOptions;
    const { eventsAllowAddingTowVehicle } = useEnabledFeatures();
    const { hasMergedEvents } = useEventMetadataStore().state.metadata ?? {};
    const allowAddingTowVehicles = useAllowAddingTowVehicles();

    return (
        <EventPanelTab title="Vehicles">
            <TabBody>
                <TabSubtitle>
                    Vehicles (<EventPanelFormArrayCount name="vehicles" />)
                </TabSubtitle>
                <FormBody>
                    <>
                        <EventPanelFormVehiclesFields
                            displayAsCards
                            form={eventForm}
                            eventPanelOptions={eventPanelOptions!}
                            hideDexFields={true}
                            allowMembersControl={true}
                            baseKey="vehicles"
                            addButtonText="Add Vehicle"
                            noMembersText="No Vehicles"
                        />
                        {eventsAllowAddingTowVehicle && (
                            <Box pt={4}>
                                <TabSubtitle>
                                    Tow Vehicles (<EventPanelFormArrayCount name="towVehicles" />)
                                </TabSubtitle>
                                <EventPanelFormVehiclesFields
                                    displayAsCards
                                    form={eventForm}
                                    eventPanelOptions={eventPanelOptions!}
                                    hideDexFields={true}
                                    asTowVehicle={true}
                                    allowMembersControl={allowAddingTowVehicles}
                                    baseKey="towVehicles"
                                    addButtonText="Add Tow Vehicle"
                                    noMembersText="No Tow Vehicles"
                                />
                            </Box>
                        )}
                        {hasMergedEvents && (
                            <Box pt={4}>
                                <TabSubtitle>
                                    Merged Vehicles (<EventPanelFormArrayCount name="mergedVehicles" />)
                                </TabSubtitle>
                                <EventPanelFormVehiclesFields
                                    displayAsCards
                                    form={eventForm}
                                    eventPanelOptions={eventPanelOptions!}
                                    hideDexFields={true}
                                    allowMembersControl={false}
                                    baseKey="mergedVehicles"
                                    noMembersText="No Merged Vehicles"
                                />
                            </Box>
                        )}

                        {hasMergedEvents && eventsAllowAddingTowVehicle && (
                            <Box pt={4}>
                                <TabSubtitle>
                                    Merged Tow Vehicles (
                                    <EventPanelFormArrayCount name="mergedTowVehicles" />)
                                </TabSubtitle>
                                <EventPanelFormVehiclesFields
                                    displayAsCards
                                    form={eventForm}
                                    eventPanelOptions={eventPanelOptions!}
                                    hideDexFields={true}
                                    asTowVehicle={true}
                                    baseKey="mergedTowVehicles"
                                    addButtonText="Add Tow Vehicle"
                                    noMembersText="No Merged Tow Vehicles"
                                />
                            </Box>
                        )}
                    </>
                </FormBody>
            </TabBody>
        </EventPanelTab>
    );
});
